module.exports = __webpack_public_path__ + "img/42.ccdfb7fd.png";